export enum OrderPageIntent {
  BUY_NOW = 'BUY_NOW',
  GIFT_CARD = 'GIFT_CARD',
  MONETARY_GIFT_CARD = 'MONETARY_GIFT_CARD',
  REDEEM_GIFT_CARD = 'REDEEM_GIFT_CARD',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
  BUY_PASS = 'BUY_PASS',
}
